import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentUtilService {

  variable: any = {}
  constructor() {
    this.variable = environment
  }
}
